import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  parseInventoryItemsRouteSearch,
  type InventoryItemsRouteSearch,
} from '../../modules/inventory/inventory-item-filter-state/route-search.js';

// WHY: the retired tags route had partNumContains; the Items list free-text search matches part.num.
function parseLegacyTagsRouteSearch(search: Record<string, unknown>): InventoryItemsRouteSearch {
  const parsed = parseInventoryItemsRouteSearch(search);
  const partNumContains =
    typeof search.partNumContains === 'string' && search.partNumContains !== ''
      ? search.partNumContains
      : undefined;
  const legacyLocationGroupId =
    typeof search.locationGroupId === 'string' && search.locationGroupId !== ''
      ? [search.locationGroupId]
      : undefined;
  return {
    ...parsed,
    search: parsed.search ?? partNumContains,
    locationGroupIds: parsed.locationGroupIds ?? legacyLocationGroupId,
  };
}

// WHY: keep this route so old /inventory/tags bookmarks still resolve to the Items list.
export const Route = createFileRoute('/inventory/tags')({
  validateSearch: parseLegacyTagsRouteSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/inventory',
      search: {
        search: search.search,
        locationId: search.locationId,
        locationGroupIds: search.locationGroupIds,
        partId: search.partId,
        lotNumberContains: search.lotNumberContains,
        // WHY: overrides the Items list's active-only default, which the old tags route never applied.
        activeOnly: false,
      },
      replace: true,
    });
  },
});
